import Vue from 'vue';

const state = {
  users: {}
}

const getters = {

  user (state) {
    return id => {
      if (id in state.users) return state.users[id];
      else return false;
    }
  },

  users (state) {
    return state.users;
  }
}

const mutations = {

  storeUsers (state, users) {
    users.forEach(user => {
      var current = state.users[user._id] || {};
      Vue.set(state.users, user._id, {
        ...current,
        ...user
      });
    });
  },

  removeUser (state, id) {
    if (id in state.users) Vue.delete(state.users, id);
  },

  clearUsers () {
    Vue.set(state, 'users', {});
  }

}


const actions = {
  
  loadUsers ({commit}, params) {
    
    var filters = params.filters || {};

    if (!params.company) {
      return Promise.reject('state.user - loading Users - Missing required param "company"');
    }

    var queryParams = {
      ...filters,
      ...{
        populateRoles: true,
        populateUnit: true,
        populateProperty: true
      }
    };

    return window.server.getReq('company/' + params.company + '/users', {
      params: queryParams
    })
    .then(data => {
      var result = storeData(data);
      // commit('storeProperties', result.properties);
      commit('storeRoles',      result.roles);
      commit('storeUnits',      result.units);
      commit('storeUsers',      result.users);
      return Promise.resolve(data);
    })  
    .catch(e => {
      return Promise.reject(e);
    });

  },
    
  loadAssignableUsers ({commit}, params) {
        
    if (!params.property) {
      return Promise.reject('state.user - loading Assignable Users - Missing required param "property"');
    }
    else if (!params.filters) {
      return Promise.reject('state.user - loading Assignable Users - Missing required param "filters"');
    }
    else if (!'search' in params.filters) {
      return Promise.reject('state.user - loading Assignable Users - Missing required param "filters.search"');
    }
    
    var filters = params.filters || {};
    
    var queryParams = {
      ...filters
    };

    return window.server.getReq('property/' + params.property + '/users/assignees', {
      params: queryParams
    })
    .then(data => {
      commit('storeUsers', data);
      return Promise.resolve(data);
    })  
    .catch(e => {
      return Promise.reject(e);
    });

  },
    
  loadUser ({commit}, params) {
    
    var filters = params.filters || {};

    if (!params.company || !params.user) {
      return Promise.reject('state.user - loading Users - Missing required param "company" || "user"');
    }

    var queryParams = {
      ...filters,
      ...{
        populateRoles: true,
        populateUnit: true,
        populateProperty: true
      }
    };

    return window.server.getReq('company/' + params.company + '/user/' + params.user, {
      params: queryParams
    })
    .then(data => {
      var result = storeData([data]);
      // commit('storeProperties', result.properties);
      commit('storeRoles',      result.roles);
      commit('storeUnits',      result.units);
      commit('storeUsers',      result.users);
      return Promise.resolve(result.users[0]);
    })  
    .catch(e => {
      return Promise.reject(e);
    });
  },

  addUserRole ({commit, dispatch}, params) {

    if (!params.user) {
      return Promise.reject('state.user - adding User Role - Missing required param "user"');
    }
    else if (!params.company) {
      return Promise.reject('state.user - adding User Role - Missing required param "company"');
    }
    else if (!params.role) {
      return Promise.reject('state.user - adding User Role - Missing required param "role"');
    }
    
    return window.server.putReq('/user/' + params.user + '/add/role/', {
      role: params.role
    })
    .then(data => {
      return dispatch('loadUser', {
        company: params.company,
        user: params.user
      })
    })
    .catch(e => {
      return Promise.reject(e);
    });

  },

  updateUserRole ({commit, dispatch}, params) {
    
    if (!params.user) {
      return Promise.reject('state.user - updating User Role - Missing required param "user"');
    }
    else if (!params.company) {
      return Promise.reject('state.user - updating User Role - Missing required param "company"');
    }
    else if (!params.role) {
      return Promise.reject('state.user - updating User Role - Missing required param "role"');
    }
    
    return window.server.putReq('/user/' + params.user + '/update/role/', {
      role: params.role
    })
    .then(data => {
      return dispatch('loadUser', {
        company: params.company,
        user: params.user
      })
    })
    .catch(e => {
      return Promise.reject(e);
    });

  },

  removeUserRole ({commit, dispatch}, params) {

    if (!params.user || !params.user._id) {
      return Promise.reject('state.user - removing User Role - Missing required param "user" - expects Object as this one also determines if a user should be removed from the state as well');
    }
    else if (!params.company) {
      return Promise.reject('state.user - removing User Role - Missing required param "company"');
    }
    else if (!params.role) {
      return Promise.reject('state.user - removing User Role - Missing required param "role"');
    }
    
    return window.server.putReq('/user/' + params.user._id + '/remove/role/', {
      role: params.role
    })
    .then(data => {
      commit('removeRole', params.role._id);

      // Check if the user's last role was removed
      if (params.user.roles.length >= 2) {
        return dispatch('loadUser', {
          company: params.company,
          user: params.user._id
        })
      }

      // Last role removed, remove them from other stuff as well
      else {
        commit('removeUser', params.user._id);
        return Promise.resolve(data);
      }

    })
    .catch(e => {
      return Promise.reject(e);
    });
  }
  
};

function storeData (users) {

  // Break out and store what we can
  var units       = {};
  var properties  = {};
  var roles       = {};

  users.forEach((user, i) => {

    user.roles.forEach((role, j) => {
      
      if (role.unit) {
        if (!(role.unit._id in units)) units[role.unit._id] = role.unit;
        users[i].roles[j].unit = role.unit._id;
      }

      if (role.property) {
        if (!(role.property._id in properties)) properties[role.property._id] = role.property;
        users[i].roles[j].property = role.property._id;
      }

      if (!(role._id in roles)) roles[role._id] = role;
      users[i].roles[j] = role._id;
    });

  }); 
  
  properties  = _.values(properties);
  units       = _.values(units);
  roles       = _.values(roles);
  
  return {
    properties,
    roles,
    units,
    users
  };
};

export default {
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js